import { NgModule } from '@angular/core';
import { RoutingConfig } from '@spartacus/core';
import { provideDefaultConfig } from '@spartacus/core';
import { AdminGuard } from '@spartacus/organization/administration/core';
import { UigAdminGuard } from './guards/uig-admin.guard';
import { UigBranchesComponentsModule } from './uig-branches/uig-branches-components.module';
import { UigUserComponentsModule } from './uig-user/uig-user-components.module';
import { UigUnitsComponentsModule } from './uig-units/uig-units-components.module';

@NgModule({
  imports: [
    UigBranchesComponentsModule,
    UigUnitsComponentsModule,
    UigUserComponentsModule
  ],
  providers: [
    {
      provide: AdminGuard,
      useClass: UigAdminGuard
    },
    provideDefaultConfig(<RoutingConfig>{
      routing: {
        routes: {
          organization: {
            paths: ['organization'],
          },
        },
      },
    }),
  ],
})
export class UigOrganizationComponentsModule { }
